import {GraphQLQuery} from '@aws-amplify/api';
import {generateClient} from 'aws-amplify/api';
import {getStripeEventPipelineHealth} from './queries';
import {EventPipelineHealth} from '../types';

export type GetStripeEventPipelineHealth = {
    getStripeEventPipelineHealth: EventPipelineHealth
}

export const DISABLED_ERROR_TYPE = 'EventPipelineHealthDisabled';

export type EventPipelineHealthResult =
    | { status: 'ok', health: EventPipelineHealth }
    | { status: 'disabled' };

const client = generateClient();

const isDisabledError = (e: unknown) => {
    const errors = (e as { errors?: { errorType?: string }[] })?.errors;
    return Array.isArray(errors) && errors.some(err => err.errorType === DISABLED_ERROR_TYPE);
};

// FNP-412: read-only stripe-api query. A stage whose API dial is off refuses
// with EventPipelineHealthDisabled; that is a state, not an error.
export const fetchEventPipelineHealth = async (
    windowStart: Date,
    windowEnd: Date,
): Promise<EventPipelineHealthResult> => {
    try {
        const response = await client.graphql<GraphQLQuery<GetStripeEventPipelineHealth>>({
            query: getStripeEventPipelineHealth,
            variables: {windowStart: windowStart.toISOString(), windowEnd: windowEnd.toISOString()},
        });
        return {status: 'ok', health: response.data.getStripeEventPipelineHealth};
    } catch (e) {
        if (isDisabledError(e)) return {status: 'disabled'};
        throw e;
    }
};
